import { globalStore } from '@store';

import { REFLECTED_STATUSES, ReflectedStatus, beastStatusAtom } from '../state/atoms';

function isReflectedStatus(status: string): status is ReflectedStatus {
    return (REFLECTED_STATUSES as string[]).includes(status);
}

export function reflectBeastStatus(status: string) {
    if (isReflectedStatus(status)) {
        globalStore.set(beastStatusAtom, status);
    }
}
